import PropTypes from 'prop-types';

const Fragment = ({ children, render }) => (
  render ? children : false
);

Fragment.propTypes = {
  children: PropTypes.node.isRequired,
  render: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
    PropTypes.string,
  ]),
};

Fragment.defaultProps = {
  render: true,
};

export default Fragment;
